class CustomError extends Error {
  code: string;
  constructor(message: string, code: string) {
    super(message);
    this.code = code;
  }
}

export interface CustomErrorType extends Error {
  code: string
}

export default CustomError;
